// Shopify Storefront API Integration with Custom Cart Drawer

const SHOPIFY_DOMAIN = 'godsalgorithm.shop'
const STOREFRONT_ACCESS_TOKEN = 'ebe31a8a11bcc7bb9ff0648dc8dd3e02'
const API_VERSION = '2024-01'

const STOREFRONT_API_URL = `https://${SHOPIFY_DOMAIN}/api/${API_VERSION}/graphql.json`

// Cart state
let cart = {
  items: [],
  checkout: null
}

let cartDrawerEl = null

/**
 * Extract numeric ID from Shopify's global ID format
 */
function extractNumericId(globalId) {
  if (!globalId) return null
  const match = globalId.match(/\/(\d+)$/)
  return match ? match[1] : null
}

/**
 * Generate direct checkout URL for a product variant (fallback)
 */
export function getCheckoutUrl(variantId, quantity = 1) {
  const numericId = variantId.includes('gid://') ? extractNumericId(variantId) : variantId
  return `https://${SHOPIFY_DOMAIN}/cart/${numericId}:${quantity}`
}

/**
 * Create the cart drawer element
 */
function createCartDrawer() {
  if (cartDrawerEl) return cartDrawerEl

  cartDrawerEl = document.createElement('div')
  cartDrawerEl.className = 'shopify-cart-drawer'
  cartDrawerEl.innerHTML = `
    <div class="cart-drawer-overlay"></div>
    <div class="cart-drawer-content">
      <div class="cart-drawer-header">
        <span class="cart-drawer-title">CART</span>
        <button class="cart-drawer-close">&times;</button>
      </div>
      <div class="cart-drawer-items"></div>
      <div class="cart-drawer-footer">
        <div class="cart-drawer-subtotal">
          <span>SUBTOTAL</span>
          <span class="cart-drawer-total">$0</span>
        </div>
        <button class="cart-drawer-checkout">CHECKOUT</button>
      </div>
    </div>
  `

  // Add styles
  const styles = document.createElement('style')
  styles.textContent = `
    .shopify-cart-drawer {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 10000;
      pointer-events: none;
      opacity: 0;
      transition: opacity 0.3s ease;
    }
    .shopify-cart-drawer.open {
      pointer-events: all;
      opacity: 1;
    }
    .cart-drawer-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
    }
    .cart-drawer-content {
      position: absolute;
      top: 0;
      right: 0;
      width: 400px;
      max-width: 90vw;
      height: 100%;
      background: #10122C;
      border-left: 1px solid #2B2C45;
      display: flex;
      flex-direction: column;
      transform: translateX(100%);
      transition: transform 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
    }
    .shopify-cart-drawer.open .cart-drawer-content {
      transform: translateX(0);
    }
    .cart-drawer-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      border-bottom: 1px solid #2B2C45;
    }
    .cart-drawer-title {
      font-family: monospace;
      font-size: 14px;
      color: #F9F9F9;
      letter-spacing: 0.1em;
    }
    .cart-drawer-close {
      background: none;
      border: none;
      color: #F9F9F9;
      font-size: 28px;
      cursor: pointer;
      padding: 0;
      line-height: 1;
      transition: color 0.2s;
    }
    .cart-drawer-close:hover {
      color: #39A289;
    }
    .cart-drawer-items {
      flex: 1;
      overflow-y: auto;
      padding: 20px;
    }
    .cart-drawer-empty {
      color: #939393;
      font-family: monospace;
      font-size: 12px;
      text-transform: uppercase;
      text-align: center;
      padding: 40px 20px;
      letter-spacing: 0.1em;
    }
    .cart-item {
      display: flex;
      gap: 15px;
      padding: 15px 0;
      border-bottom: 1px solid #2B2C45;
    }
    .cart-item-image {
      width: 80px;
      height: 80px;
      object-fit: cover;
      border: 1px solid #2B2C45;
    }
    .cart-item-details {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .cart-item-title {
      font-family: monospace;
      font-size: 12px;
      color: #F9F9F9;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }
    .cart-item-price {
      font-family: monospace;
      font-size: 12px;
      color: #939393;
    }
    .cart-item-quantity {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .cart-item-qty-btn {
      background: none;
      border: 1px solid #2B2C45;
      color: #F9F9F9;
      width: 24px;
      height: 24px;
      cursor: pointer;
      font-family: monospace;
      transition: background 0.2s, border-color 0.2s;
    }
    .cart-item-qty-btn:hover {
      background: #2B2C45;
      border-color: #39A289;
    }
    .cart-item-qty {
      font-family: monospace;
      font-size: 12px;
      color: #F9F9F9;
      min-width: 20px;
      text-align: center;
    }
    .cart-item-remove {
      background: none;
      border: none;
      color: #939393;
      font-size: 18px;
      cursor: pointer;
      padding: 0;
      margin-left: auto;
      transition: color 0.2s;
    }
    .cart-item-remove:hover {
      color: #ff6b6b;
    }
    .cart-drawer-footer {
      padding: 20px;
      border-top: 1px solid #2B2C45;
    }
    .cart-drawer-subtotal {
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;
      font-family: monospace;
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: 0.1em;
    }
    .cart-drawer-subtotal span:first-child {
      color: #939393;
    }
    .cart-drawer-total {
      color: #F9F9F9;
    }
    .cart-drawer-checkout {
      width: 100%;
      padding: 15px;
      background: #39A289;
      color: #10122C;
      border: none;
      font-family: monospace;
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: 0.1em;
      cursor: pointer;
      transition: background 0.2s;
    }
    .cart-drawer-checkout:hover {
      background: #2d8a73;
    }
    .cart-drawer-checkout:disabled {
      background: #2B2C45;
      color: #939393;
      cursor: not-allowed;
    }
  `

  document.head.appendChild(styles)
  document.body.appendChild(cartDrawerEl)

  // Event listeners
  cartDrawerEl.querySelector('.cart-drawer-overlay').addEventListener('click', closeCart)
  cartDrawerEl.querySelector('.cart-drawer-close').addEventListener('click', closeCart)
  cartDrawerEl.querySelector('.cart-drawer-checkout').addEventListener('click', goToCheckout)

  return cartDrawerEl
}

/**
 * Render cart items
 */
function renderCartItems() {
  const drawer = createCartDrawer()
  const itemsContainer = drawer.querySelector('.cart-drawer-items')
  const totalEl = drawer.querySelector('.cart-drawer-total')
  const checkoutBtn = drawer.querySelector('.cart-drawer-checkout')

  if (cart.items.length === 0) {
    itemsContainer.innerHTML = '<div class="cart-drawer-empty">Your cart is empty</div>'
    totalEl.textContent = '$0'
    checkoutBtn.disabled = true
    return
  }

  checkoutBtn.disabled = false
  
  let total = 0
  itemsContainer.innerHTML = cart.items.map((item, index) => {
    const itemTotal = item.price * item.quantity
    total += itemTotal
    return `
      <div class="cart-item" data-index="${index}">
        <img src="${item.image || '/src/assets/images/placeholder.jpg'}" alt="${item.title}" class="cart-item-image">
        <div class="cart-item-details">
          <div class="cart-item-title">${item.title}</div>
          <div class="cart-item-price">$${item.price.toFixed(0)}</div>
          <div class="cart-item-quantity">
            <button class="cart-item-qty-btn" data-action="decrease" data-index="${index}">-</button>
            <span class="cart-item-qty">${item.quantity}</span>
            <button class="cart-item-qty-btn" data-action="increase" data-index="${index}">+</button>
          </div>
        </div>
        <button class="cart-item-remove" data-index="${index}">&times;</button>
      </div>
    `
  }).join('')

  totalEl.textContent = `$${total.toFixed(0)}`

  // Add event listeners for quantity buttons
  itemsContainer.querySelectorAll('.cart-item-qty-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const index = parseInt(e.target.dataset.index)
      const action = e.target.dataset.action
      if (action === 'increase') {
        cart.items[index].quantity++
      } else if (action === 'decrease' && cart.items[index].quantity > 1) {
        cart.items[index].quantity--
      }
      renderCartItems()
    })
  })

  // Add event listeners for remove buttons
  itemsContainer.querySelectorAll('.cart-item-remove').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const index = parseInt(e.target.dataset.index)
      cart.items.splice(index, 1)
      renderCartItems()
    })
  })
}

/**
 * Open cart drawer
 */
export function openCart() {
  const drawer = createCartDrawer()
  renderCartItems()
  drawer.classList.add('open')
  document.body.style.overflow = 'hidden'
}

/**
 * Close cart drawer
 */
export function closeCart() {
  if (cartDrawerEl) {
    cartDrawerEl.classList.remove('open')
    document.body.style.overflow = ''
  }
}

/**
 * Go to Shopify checkout
 */
async function goToCheckout() {
  if (cart.items.length === 0) return

  // Build cart URL with all items
  const cartItems = cart.items.map(item => {
    const numericId = item.variantId.includes('gid://') 
      ? extractNumericId(item.variantId) 
      : item.variantId
    return `${numericId}:${item.quantity}`
  }).join(',')

  const checkoutUrl = `https://${SHOPIFY_DOMAIN}/cart/${cartItems}`
  window.location.href = checkoutUrl
}

/**
 * Add a product to cart and open the drawer
 */
export async function addToCart(product, quantity = 1) {
  // Check if item already exists in cart
  const existingIndex = cart.items.findIndex(item => item.variantId === product.variantId)
  
  if (existingIndex > -1) {
    cart.items[existingIndex].quantity += quantity
  } else {
    cart.items.push({
      variantId: product.variantId,
      title: product.title,
      price: product.price,
      image: product.image,
      quantity: quantity
    })
  }

  openCart()
}

// GraphQL query to fetch all products
const PRODUCTS_QUERY = `
  query GetProducts($first: Int!) {
    products(first: $first) {
      edges {
        node {
          id
          title
          handle
          description
          availableForSale
          totalInventory
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
          images(first: 10) {
            edges {
              node {
                url
                altText
              }
            }
          }
          variants(first: 1) {
            edges {
              node {
                id
                availableForSale
                quantityAvailable
              }
            }
          }
        }
      }
    }
  }
`

/**
 * Fetch products from Shopify Storefront API
 */
export async function fetchProducts(limit = 50) {
  try {
    const response = await fetch(STOREFRONT_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
      },
      body: JSON.stringify({
        query: PRODUCTS_QUERY,
        variables: { first: limit }
      })
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()

    if (data.errors) {
      console.error('Shopify API Errors:', data.errors)
      throw new Error(data.errors[0].message)
    }

    return data.data.products.edges.map(({ node }) => {
      const variantId = node.variants.edges[0]?.node?.id
      const images = node.images.edges.map(edge => ({
        url: edge.node.url,
        alt: edge.node.altText || node.title
      }))
      return {
        id: node.id,
        title: node.title,
        handle: node.handle,
        description: node.description,
        availableForSale: node.availableForSale,
        totalInventory: node.totalInventory,
        price: parseFloat(node.priceRange.minVariantPrice.amount),
        currency: node.priceRange.minVariantPrice.currencyCode,
        images: images,
        image: images[0]?.url || null,
        imageAlt: images[0]?.alt || node.title,
        variantId: variantId,
        url: `https://${SHOPIFY_DOMAIN}/products/${node.handle}`,
        checkoutUrl: variantId ? getCheckoutUrl(variantId) : null
      }
    })
  } catch (error) {
    console.error('Error fetching products:', error)
    throw error
  }
}

/**
 * Format price for display
 */
export function formatPrice(price, currency = 'USD') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(price)
}

// Layout patterns for product grid
const LAYOUT_PATTERNS = [
  { class: 'right bottom', scrollSpeed: null },
  { class: 'closeLeft', scrollSpeed: null },
  { class: 'left bottom overlap', scrollSpeed: '1.6' },
  { class: 'right', scrollSpeed: null },
  { class: 'middle overlap bottom', scrollSpeed: '1.2' },
  { class: 'closeLeft bottom', scrollSpeed: null },
  { class: 'right', scrollSpeed: '1.8' },
  { class: 'closeLeft', scrollSpeed: null },
  { class: 'left bottom overlap', scrollSpeed: '1.3' },
  { class: 'closeRight', scrollSpeed: null }
]

/**
 * Render products into the DOM
 */
export function renderProducts(products, container) {
  if (!container) {
    console.error('Products container not found')
    return
  }

  container.innerHTML = ''

  products.forEach((product, index) => {
    const pattern = LAYOUT_PATTERNS[index % LAYOUT_PATTERNS.length]
    const isFirstProduct = index === 0
    
    const productEl = document.createElement('div')
    productEl.className = `${pattern.class} product${isFirstProduct ? ' appear' : ''}`
    productEl.setAttribute('data-scroll', '')
    
    if (pattern.scrollSpeed) {
      productEl.setAttribute('data-scroll-speed', pattern.scrollSpeed)
    }

    const inventoryDisplay = product.totalInventory ? `/${product.totalInventory}` : ''
    const isSoldOut = !product.availableForSale || product.totalInventory === 0

    const hasMultipleImages = product.images && product.images.length > 1
    
    productEl.innerHTML = `
      <button class="product-link" ${isSoldOut ? 'disabled aria-disabled="true"' : ''}>
        <div class="product-img">
          <img src="${product.image || '/src/assets/images/placeholder.jpg'}" alt="${product.imageAlt}" data-current-index="0">
          ${isSoldOut ? '<div class="product-sold-out">SOLD OUT</div>' : '<div class="product-buy-overlay">ADD TO CART</div>'}
          ${hasMultipleImages ? `
            <div class="product-img-prev" role="button" aria-label="Previous image">&#8592;</div>
            <div class="product-img-next" role="button" aria-label="Next image">&#8594;</div>
            <div class="product-img-dots">
              ${product.images.map((_, i) => `<span class="product-img-dot${i === 0 ? ' active' : ''}" data-index="${i}"></span>`).join('')}
            </div>
          ` : ''}
        </div>
      </button>
      <div class="product-content">
        <div class="product-name">${product.title}</div>
        <div class="product-price">${formatPrice(product.price, product.currency)}</div>
        ${inventoryDisplay ? `<div class="product-quantity">${inventoryDisplay}</div>` : ''}
      </div>
    `

    // Image navigation handlers
    if (hasMultipleImages) {
      const img = productEl.querySelector('.product-img img')
      const dots = productEl.querySelectorAll('.product-img-dot')
      const prevBtn = productEl.querySelector('.product-img-prev')
      const nextBtn = productEl.querySelector('.product-img-next')
      if (!prevBtn || !nextBtn) return
      
      const updateImage = (newIndex) => {
        img.src = product.images[newIndex].url
        img.alt = product.images[newIndex].alt
        img.dataset.currentIndex = newIndex
        dots.forEach((dot, i) => dot.classList.toggle('active', i === newIndex))
      }
      
      prevBtn.addEventListener('click', (e) => {
        e.stopPropagation()
        e.preventDefault()
        const current = parseInt(img.dataset.currentIndex)
        const newIndex = current === 0 ? product.images.length - 1 : current - 1
        updateImage(newIndex)
      })
      
      nextBtn.addEventListener('click', (e) => {
        e.stopPropagation()
        e.preventDefault()
        const current = parseInt(img.dataset.currentIndex)
        const newIndex = current === product.images.length - 1 ? 0 : current + 1
        updateImage(newIndex)
      })
      
      dots.forEach(dot => {
        dot.addEventListener('click', (e) => {
          e.stopPropagation()
          e.preventDefault()
          updateImage(parseInt(dot.dataset.index))
        })
      })
    }

    // Add click handler
    const button = productEl.querySelector('.product-link')
    if (!isSoldOut && product.variantId) {
      button.addEventListener('click', async (e) => {
        e.preventDefault()
        
        const overlay = button.querySelector('.product-buy-overlay')
        const originalText = overlay.textContent
        overlay.textContent = 'ADDING...'
        
        try {
          await addToCart(product)
          overlay.textContent = 'ADDED!'
          setTimeout(() => {
            overlay.textContent = originalText
          }, 1500)
        } catch (error) {
          console.error('Failed to add to cart:', error)
          overlay.textContent = 'ERROR'
          setTimeout(() => {
            overlay.textContent = originalText
          }, 1500)
        }
      })
    }

    container.appendChild(productEl)
  })
}

/**
 * Initialize the Shopify products section
 */
export async function initShopifyProducts(containerSelector = '.products') {
  const container = document.querySelector(containerSelector)
  
  if (!container) {
    console.error('Products container not found:', containerSelector)
    return
  }

  try {
    container.innerHTML = '<div class="products-loading">Loading products...</div>'
    
    const products = await fetchProducts()
    
    if (products.length === 0) {
      container.innerHTML = '<div class="products-empty">No products available</div>'
      return
    }

    renderProducts(products, container)
    
    window.dispatchEvent(new CustomEvent('shopify:products-loaded', { detail: { products } }))
    
  } catch (error) {
    console.error('Failed to load products:', error)
    container.innerHTML = '<div class="products-error">Failed to load products. Please try again later.</div>'
  }
}

export default {
  fetchProducts,
  formatPrice,
  renderProducts,
  initShopifyProducts,
  getCheckoutUrl,
  addToCart,
  openCart,
  closeCart
}
